import { baseRouters } from "@/router/routers";
import Layout from "@/components/Layout/Index";

const permission = {
  state: {
    routers: baseRouters,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      //组合基础路由和接口给的路由
      state.addRouters = routers;
      state.routers = baseRouters.concat(routers);
    }
  },
  actions: {
    GenerateRoutes({ commit }, asyncRouter) {
      //提供方法给页面，实现动态路由
      commit("SET_ROUTERS", asyncRouter);
    }
  }
};

export const filterAsyncRouter = routers => {
  // 遍历后台传来的路由字符串，转换为组件对象
  return routers.filter(router => {
    if (router.component) {
      if (router.component === "Layout") {
        // Layout组件特殊处理
        router.component = Layout;
      } else {
        const component = router.component;
        router.component = loadView(component);
      }
    }
    if (router.name === "CityDetail") {
      router.beforeEnter = (to, from, next) => {
        for (const item of to.matched) {
          if (item.path == "/master/detail/:id") {
            item.meta.title = to.query.name ? to.query.name : "同城详情";
            document.title = item.meta.title + "-中台管理系统";
          }
        }
        next();
      };
    }
    if (router.children && router.children.length) {
      router.children = filterAsyncRouter(router.children);
    }
    return true;
  });
};

export const loadView = view => {
  return resolve => require([`@/views/${view}`], resolve);
};

export default permission;
